import { render, staticRenderFns } from "./Disparities.vue?vue&type=template&id=52b6bd7a"
import script from "./Disparities.vue?vue&type=script&lang=js"
export * from "./Disparities.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports